<template>

</template>

<script>
  export default {
    data() {
      return {

      };
    },
    computed:{
      token(){
        return this.$store.getters.token;
      }
    },
    methods: {
      getDanwei(){
        var params = new URLSearchParams();
        params.append('token', 'cqgU1wqtfzcZRAniU');
        params.append('admin', this.$store.getters.name);
        params.append('my', this.$store.getters.token);
        this.$ajax.post("/apis/danwei.php",params).then((ret) => {
          if (ret.data != "token错误" && ret.data != "数据库连接失败") 
          this.$store.commit('setDanwei', ret.data.sort(this.compare));
        });
      },
      getCheliang(){
        var params = new URLSearchParams();
        params.append('token', 'cqgU1wqtfzcZRAniU');
        params.append('admin', this.$store.getters.name);
        params.append('my', this.$store.getters.token);
        this.$ajax.post("/apis/cheliang.php",params).then((ret) => {
          if (ret.data != "token错误" && ret.data != "数据库连接失败")
            this.$store.commit('setCheliang', ret.data.sort(this.compare));
        });
      },
      getXueyuan(){
        var params = new URLSearchParams();
        params.append('token', 'cqgU1wqtfzcZRAniU');
        params.append('admin', this.$store.getters.name);
        params.append('my', this.$store.getters.token);
        this.$ajax.post("/apis/xueyuan.php",params).then((ret) => {
          if (ret.data != "token错误" && ret.data != "数据库连接失败")
            this.$store.commit('setXueyuan', ret.data.sort(this.compare));
        });
      },
      getText(){
        var params = new URLSearchParams();
        params.append('token', 'cqgU1wqtfzcZRAniU');
        params.append('admin', this.$store.getters.name);
        params.append('my', this.$store.getters.token);
        this.$ajax.post("/apis/text.php",params).then((ret) => {
          if (ret.data != "token错误" && ret.data != "数据库连接失败")
            this.$store.commit('setText', ret.data.sort(this.compare));
        });
      },
      getStudy(){
        var params = new URLSearchParams();
        params.append('token', 'cqgU1wqtfzcZRAniU');
        params.append('admin', this.$store.getters.name);
        params.append('my', this.$store.getters.token);
        this.$ajax.post("/apis/study.php",params).then((ret) => {
          if (ret.data != "token错误" && ret.data != "数据库连接失败")
            this.$store.commit('setStudy', ret.data.sort(this.compare));
        });
      },
      getExam(){
        var params = new URLSearchParams();
        params.append('token', 'cqgU1wqtfzcZRAniU');
        params.append('admin', this.$store.getters.name);
        params.append('my', this.$store.getters.token);
        this.$ajax.post("/apis/exam.php",params).then((ret) => {
            this.loading = false;
            if (ret.data != "token错误" && ret.data != "数据库连接失败")
              this.$store.commit('setExam', ret.data.sort(this.compare));
        });
      },
      getYh(){
        var params = new URLSearchParams();
        params.append('token', 'cqgU1wqtfzcZRAniU');
        params.append('admin', this.$store.getters.name);
        params.append('my', this.$store.getters.token);
        this.$ajax.post("/apis/yh.php",params).then((ret) => {
              this.loading = false;
              if (ret.data != "token错误" && ret.data != "数据库连接失败")
                this.$store.commit('setYh', ret.data.sort(this.compare));
        });
      },

      compare(v1, v2){
        if (Number(v1.id) < Number(v2.id)){
          return 1;
        }else if (Number(v1.id) > Number(v2.id)){
          return -1;
        }else{
          return 0;
        }
      }
    },
    created(){
      let date=new Date;
      let year=date.getFullYear(); 
      let month=date.getMonth()+1;
      month =(month<10 ? "0"+month:month); 
      this.$store.state.now = (year.toString()+month.toString());

      if(this.token) {
        if (this.$store.state.sext.length == 0) this.getStudy();
        if (this.$store.state.danwei.length == 0) this.getDanwei();
        if (this.$store.state.cheliang.length == 0) this.getCheliang();
        if (this.$store.state.xueyuan.length == 0) this.getXueyuan();
        if (this.$store.state.sext.length == 0) this.getText();
        if (this.$store.state.exam.length == 0) this.getExam();
        if (this.$store.state.yh.length == 0) this.getYh();
      }
    },
    watch: {
      token: function (newtoken, oldtoken) {
        if (this.$store.state.sext.length == 0) this.getStudy();
        if (this.$store.state.danwei.length == 0) this.getDanwei();
        if (this.$store.state.cheliang.length == 0) this.getCheliang();
        if (this.$store.state.xueyuan.length == 0) this.getXueyuan();
        if (this.$store.state.sext.length == 0) this.getText();
        if (this.$store.state.exam.length == 0) this.getExam();
        if (this.$store.state.yh.length == 0) this.getYh();
      }
    }

  }

  Date.prototype.Format = function(fmt)   { //author: meizz   
    var o = {   
      "M+" : this.getMonth()+1,                 //月份   
      "d+" : this.getDate(),                    //日   
      "h+" : this.getHours(),                   //小时   
      "m+" : this.getMinutes(),                 //分   
      "s+" : this.getSeconds(),                 //秒   
      "q+" : Math.floor((this.getMonth()+3)/3), //季度   
      "S"  : this.getMilliseconds()             //毫秒   
    };   
    if(/(y+)/.test(fmt))   
      fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));   
    for(var k in o)   
      if(new RegExp("("+ k +")").test(fmt))   
    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));   
    return fmt;   
  }
</script>

<style>

html,body,#app,.el-container {height: 100%;}

img{
  display: block;
}
/*.el-container .el-main{height: 100%;}

.el-main .container{height: 90%;}*/

.el-header {
  background-color:#545c64;
}

.el-aside {
  background-color: #545c64;
  border-right:solid 1px #e6e6e6;
}

.el-aside .el-menu-item {
  min-width: 0px;
}

.el-aside .el-menu{
  border-right:solid 0px #e6e6e6;
}

.el-header{
  padding: 0px;
}

.el-header .el-menu--horizontal{
  border-bottom: solid 0px #e6e6e6;
}

.el-header .el-menu{
  padding-left: 150px;
}

.el-footer{
  margin: auto;
  width: 40%;
  border-top:solid 1px #cccccc;
  color: #cccccc;
  font-size: 10px;
  text-align: center;
}

.container{
  margin-left: auto;
  margin-right: auto;
}
.el-table td{
  padding: 5px;
}
.el-dialog .el-input{
  width: 80%
}
.el-dialog .el-select{
  display: block;
}
.el-dialog .el-input-number .el-input{
  width: 100%
}

.quill-editor {
  height: 85%;
}
.ql-snow .ql-picker{
  height: 31px;
}
.ql-snow .ql-picker.ql-size{
  height: 34px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue